import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  WxrlLogsMode,
  WxrlRuleLogsFilter,
} from '../../services/wxrl-logs.service';

@Component({
  selector: 'afoone-wxrl-rule-logs-filters',
  templateUrl: './wxrl-rule-logs-filters.component.html',
  styleUrls: ['./wxrl-rule-logs-filters.component.css'],
})
export class WxrlRuleLogsFiltersComponent {
  @Input() fixedRule: boolean = false;
  @Input() public totalOccurrences: number = 0;
  @Input() public currentOccurrences: number = 0;

  @Output() public search: EventEmitter<WxrlRuleLogsFilter> =
    new EventEmitter();
  public searchType: WxrlLogsMode = 'rule';
  public subjectID?: number;
  public labNr?: number;
  public ruleState?: string;
  public subjectType?: string;
  public desde?: Date;
  public hasta?: Date;
  public maxRows = 5000;
  public text?: string;

  public today = new Date();

  onSearchTypeChanged(event: any) {
    this.searchType = event.value;
  }

  // función helper para quitar ajuste de zona horaria
  toLocalDateTime = (date?: Date): Date | undefined => {
    if (!date) return undefined;

    // Crea un nuevo Date con los mismos valores de año, mes, día, hora, min, seg
    return new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds()
    );
  };

  onSearch() {
    const filters: WxrlRuleLogsFilter = {
      subjectID: this.subjectID,
      labNr: this.labNr,
      ruleState: this.ruleState,
      subjectType: this.subjectType,
      desde:this.desde,
      hasta: this.hasta,
      maxRows: this.maxRows,
      mode: this.searchType,
      text: this.text,
    };
    this.search.emit(filters);
  }
}
